import api, { unwrap } from './client';
import type { ApiResponse } from '@/types/api';
import type { CustomerPickerResponse, CustomerResponse } from '@/types/customer';

export interface CustomerBillingSearchResponse {
  results: CustomerResponse[];
  totalHits: number;
}

export interface QuickCustomerRequest {
  phone: string;
  name?: string;
}

export const customersBillingApi = {
  walkIn: () =>
    unwrap(api.get<ApiResponse<CustomerResponse>>('/v1/customers/billing/walk-in')),

  search: (q: string) =>
    unwrap(
      api.get<ApiResponse<CustomerBillingSearchResponse>>('/v1/customers/billing/search', {
        params: { q },
      }),
    ),

  quickCreate: (body: QuickCustomerRequest) =>
    unwrap(api.post<ApiResponse<CustomerResponse>>('/v1/customers/billing/quick', body)),

  recent: (limit = 8) =>
    unwrap(
      api.get<ApiResponse<CustomerPickerResponse[]>>('/v1/customers/billing/recent', {
        params: { limit },
      }),
    ),
};
